import AddApp from "./AddApp";
import AppsList from "./AppsList";
import Details from "./Details";
import useLocalStorage from "../hooks/useLocalStorage";
import EditApp from "./EditApp";
import AppsContext from "../context/AppsContext";
import { Tabs, Tab } from "@mui/material";
import {
  Apps as AppsIcon,
  Add as AddIcon,
  Create as CreateIcon,
  TableView as TableViewIcon,
} from "@mui/icons-material";
import { Container, Row } from "react-bootstrap";
import { BrowserRouter, Link, Switch, Route, Redirect } from "react-router-dom";
import Header from "./Header";
import React, { Fragment, useState, useEffect } from "react";
import _ from "lodash";
import { API } from "aws-amplify";
import * as queries from "../graphql/queries";
import { tokenManager } from "../utils/tokenUtils";
import { AboutInfo } from "../components/AboutInfo";

const Main = ({ user }) => {
  const routes = ["/", "/add", "/edit", "/details"];
  const [apps, setApps] = useLocalStorage("apps", []);
  const [email] = useState(
    _.get(user, "attributes.email") || 
    _.get(user, "username") || 
    _.get(user, "signInUserSession.idToken.payload.email") ||
    _.get(user, "signInUserSession.idToken.payload.username") ||
    _.get(user, "signInUserSession.idToken.payload['cognito:username']")
  );
  const [permissions, setPermissions] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchPermissions() {
      try {
        const result = await tokenManager.makeAuthenticatedRequest(async (token) => {
          return await API.graphql({
            authMode: "AWS_LAMBDA",
            authToken: `Bearer ${token}`,
            query: queries.getUserPermissions
          });
        });
        setPermissions(result.data.getUserPermissions);
      } catch (error) {
        setPermissions({ isAdmin: false, isOperator: false, isReadOnly: false });
      } finally {
        setLoading(false);
      }
    }
    fetchPermissions();
  }, []);

  if (loading) {
    return <div>Loading permissions...</div>;
  }

  const { isAdmin, isOperator, isReadOnly, group } = permissions || { isAdmin: false, isOperator: false, isReadOnly: false, group: null };
  const entity = process.env.REACT_APP_EntityName;
  if (!isAdmin && !isOperator && !isReadOnly) {
    return (
      <main>
        <Fragment>
          <Container fluid="md">
            <Header/>
          </Container>
        </Fragment>
        <div class="message">
          Can't display any DR details. User[{email}] is not found to be part of any valid DR group.
          Please add user to a valid DR group & sign-in again !!!
        </div>
      </main>
    );
  }
  return (
    <main>
      <AboutInfo
        isAdmin={isAdmin}
        isOperator={isOperator}
        isReadOnly={isReadOnly}
        email={email}
        entity={entity}
        group={group}
      />
      <BrowserRouter>
        <div>
          <Route
            path="/"
            render={({ location }) => (
              <Fragment>
                <Container fluid="md">
                  <Header />
                  <Row className="justify-content-md-center">
                    <Tabs
                      value={
                        (isOperator || isReadOnly) && location.pathname.startsWith("/edit")
                          ? "/details"
                          : location.pathname === `/edit/${location.pathname.split("/edit/")[1]}`
                          ? "/edit"
                          : location.pathname
                      }
                      indicatorColor="secondary"
                      textColor="inherit"
                    >
                      <Tab
                        style={{ color: "white" }}
                        icon={<AppsIcon />}
                        label="Plans"
                        value={routes[0]}
                        to={routes[0]}
                        component={Link}
                      />
                      {/* Only render create/edit plan tabs for isAdmin */}
                      { isAdmin && (
                        <Tab
                          style={{ color: "white" }}
                          icon={<AddIcon />}
                          label="Create Plan"
                          value={routes[1]}
                          to={routes[1]}
                          component={Link}
                          // disabled={!isAdmin}
                        />
                      )}
                      { isAdmin && (
                        <Tab
                          style={{ color: "white" }}
                          icon={<CreateIcon />}
                          label="Edit Plan"
                          value={routes[2]}
                          to={routes[2]}
                          component={Link}
                          // disabled={!isAdmin}
                        />
                      )}      
                      <Tab
                        style={{ color: "white" }}
                        icon={<TableViewIcon />}
                        label="Details"
                        value={routes[3]}
                        to={routes[3]}
                        component={Link}
                        // disabled={!isAdmin}
                      />
                    </Tabs>
                  </Row>
                </Container>
                <div className="main-content">
                  <AppsContext.Provider value={{ apps, setApps }}>
                    <Switch>
                      <Route
                        render={(props) => (
                          <AppsList {...props} user={user} isAdmin={isAdmin} isOperator={isOperator}/>
                        )}
                        path="/"
                        exact={true}
                      />
                      <Route
                        render={(props) => (
                          <Details {...props} user={user} isAdmin={isAdmin} />
                        )}
                        path="/details"
                        exact={true}
                      />

                      {isAdmin && (
                        <Route
                          render={(props) => (
                            <AddApp {...props} user={user} isAdmin={isAdmin} isOperator={isOperator} />
                          )}
                          path="/add"
                          // exact={true}
                        />
                      )}

                      <Route
                        render={(props) => (
                          <EditApp {...props} user={user} isAdmin={isAdmin} isOperator={isOperator} />
                        )}
                        path="/edit/:id"
                        // exact={true}
                      />

                      <Route component={() => <Redirect to="/" />} />
                    </Switch>
                  </AppsContext.Provider>
                </div>
              </Fragment>
            )}
          />
        </div>
      </BrowserRouter>
    </main>
  );
};



export default Main;
